import { checkValidityInn, renderLengthFieldRule, renderRequiredRule, renderValidator } from '@/utils/renderRulesForm';

export default (thirdPerson) => ({
  cargoTransportationCustomer: [
    renderRequiredRule('Пожалуйста выберите заказчика'),
    {
      validator: (rule, value, callback) => {
        if (thirdPerson.cargoTransportationCustomer && value === '') {
          callback(new Error('Пожалуйста выберите заказчика'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  typeThirdPerson: [],
  innThirdPerson: [
    renderRequiredRule('Пожалуйста введите ИНН'),
    renderValidator({
      validatorFunc: (value) => {
        return checkValidityInn(value);
      },
      message: 'Некорректно введён ИНН',
    }),
    renderLengthFieldRule({
      min: 10,
      max: 12,
      message: 'ИНН должен состоять от 10 до 12 символов',
    }),
  ],
  name: [renderRequiredRule('Пожалуйста введите название организации')],
  fioThirdPerson: [
    renderRequiredRule('Введите ФИО', 'change'),
    {
      validator: (rule, value, callback) => {
        value
          .trim()
          .split(' ')
          .forEach((value) => {
            if (value.length < 2) {
              callback(new Error('Слишком коротко'));
              return;
            }
          });

        callback();
      },
      trigger: 'blur',
    },
    {
      validator: (rule, value, callback) => {
        if (value.trim().split(' ').length !== 3) {
          callback(new Error('Некорректное ФИО'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],

  phoneThirdPerson: [
    renderRequiredRule('Введите телефон'),
    renderValidator({
      validatorFunc: (value) => !!value.match(/^\+{0,1}\d \([346-9]\d{2}\) \d{3}-\d{2}-\d{2}$/),
      message: 'Некорректно введён номер',
    }),
  ],
  emailThirdPerson: [
    {
      required: thirdPerson.typeThirdPerson || thirdPerson.cargoTransportationCustomer === 'Получатель',
      message: 'Введите почту',
      trigger: 'change',
    },
    {
      validator: (rule, value, callback) => {
        if (
          (thirdPerson.typeThirdPerson && value === '') ||
          (!(value === '') && !value.match(/(^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,}$)|(^([а-яa-z0-9_-]+\.)*[а-яa-z0-9_-]+@[а-я0-9_-]+(\.[а-я0-9_-]+)*\.[а-я]{2,}$)/))
        ) {
          callback(new Error('Пожалуйста введите почту'));
        }
        callback();
      },
      trigger: 'blur',
    },
  ],
  whoPaysCargoTransportation: [renderRequiredRule('Пожалуйста выберите плательщика', 'change')],
  typeOfPaymentCargoTransportation: [renderRequiredRule('Пожалуйста выберите тип оплаты', 'change')],
});
